// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSeasonLeaderboardGetBody = {
  poolId: string;
  seasonId: string;
};

export type typeSeasonLeaderboardGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    season: {
      seasonId: string;
      seasonYear: number;
      seasonTitle: string;
      isCurrent: boolean;
      startedAt: string;
      endedAt?: string | null;
    };
    members: {
      userId: string;
      displayName: string;
      rank: number;
      pointsTotal: number;
      medalsEarned: number;
      medalsCustom: number;
      trophiesEarned: number;
      trophiesCustom: number;
    }[];
  };
};

export type typeSeasonLeaderboardGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSeasonLeaderboardGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSeasonLeaderboardGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSeasonLeaderboardGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "seasonId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSeasonLeaderboardGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSeasonLeaderboardGetBody);
  }

  return async function postSeasonLeaderboardGet(
    payload: typeSeasonLeaderboardGetBody,
  ): Promise<
    typeSeasonLeaderboardGetOutput200 | typeSeasonLeaderboardGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSeasonLeaderboardGet" failed before calling the network. #55bc3c805cf4`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#55bc3c805cf4" },
        },
        data: null,
      } as typeSeasonLeaderboardGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/season/leaderboard-get`,
      httpMethod: "POST",
      options,
    })) as
      typeSeasonLeaderboardGetOutput200 | typeSeasonLeaderboardGetOutput400;
  };
}
